import { onMounted, onUnmounted, ref, type Ref } from 'vue';
import { useLocalSettings } from '../../stores/localSettingsStore';

interface ScannerInputOptions {
  capture?: boolean;
  onInput?: (value: string) => void | boolean;
  transform?: (value: string) => string;
}

export const useScannerInput = (
  scannerValue: Ref<string> = ref(''),
  options: ScannerInputOptions = {},
) => {
  const { capture, onInput, transform } = options;
  const { localScannerSettings } = useLocalSettings();

  let lastKeyPressTime = 0;
  let inputBuffer = '';

  const handleKeyDown = (event: KeyboardEvent) => {
    const { keyPressDelayThreshold } = localScannerSettings.value;
    const currentTime = Date.now();

    if (currentTime - lastKeyPressTime > keyPressDelayThreshold) {
      inputBuffer = '';
    }
    lastKeyPressTime = currentTime;

    if (event.key.length === 1) inputBuffer += event.key;
    if (event.key === 'Enter' && inputBuffer.length > 0) {
      event.preventDefault();
      event.stopPropagation();

      if (transform) inputBuffer = transform(inputBuffer);
      scannerValue.value = inputBuffer;
      if (onInput) {
        const stop = onInput(inputBuffer);
        if (stop === false) event.stopImmediatePropagation();
      }
      inputBuffer = '';
    }
  };

  onMounted(() => window.addEventListener('keydown', handleKeyDown, { capture }));
  onUnmounted(() => window.removeEventListener('keydown', handleKeyDown));

  return {
    trackValue: scannerValue,
  };
};
